












































































import {
  computed,
  defineComponent,
  onUnmounted,
  ref,
  useContext,
  useStore,
  watch,
} from '@nuxtjs/composition-api'
import AuthTabsSwitcher, { AuthTab } from './AuthTabsSwitcher.vue'
import AuthBlitzFrame from './AuthBlitzFrame.vue'
import CabinetHeroCard from './CabinetHeroCard.vue'
import CabinetRowCard from './CabinetRowCard.vue'
import { isCabinetClickable } from './cabinet'
import TeleportV2 from '@/components/TeleportV2.vue'
import RgsModalAside from '@/components/RgsModalAside.vue'
import { CardsLkItem } from '@/contracts/CardsLk'
import { yaReach } from '@/composition/ym'
import { useBlitzPostMessage } from '@/composition/useBlitzPostMessage'

const MODAL_ID = 'modal-auth-account'
const MOBILE_QUERY = '(max-width: 639px)'

export default defineComponent({
  name: 'AuthAccountModal',
  components: {
    TeleportV2,
    RgsModalAside,
    AuthTabsSwitcher,
    AuthBlitzFrame,
    CabinetHeroCard,
    CabinetRowCard,
  },
  setup() {
    const store = useStore()
    const ctx = useContext()
    const modalRef = ref<{ onClose: () => void } | null>(null)

    const isVisible = computed(
      () => store.getters['modal/GET_MODAL'] === MODAL_ID
    )
    const accountModalData = computed(
      () => store.getters['settings/getAuthModalData']?.[MODAL_ID] || {}
    )
    const clientsFrameSrc = computed<string | null>(
      () => accountModalData.value.blitzFrameSrc || null
    )
    const authTitle = computed<string>(
      () => accountModalData.value.authTitle || 'Вход'
    )
    const businessItems = computed<CardsLkItem[]>(
      () => store.getters['cardsLk/businessItems']
    )

    const activeTab = ref<AuthTab>('clients')
    const activeCabinetUrl = ref<string | null>(null)
    const requested = ref(false)
    const fetched = computed(
      () => requested.value && !store.getters['cardsLk/isLoading']
    )
    const isMobile = ref(false)

    const isCabinetFrameOpen = computed(
      () => activeTab.value === 'business' && Boolean(activeCabinetUrl.value)
    )
    const isEmpty = computed(
      () =>
        !clientsFrameSrc.value && fetched.value && !businessItems.value.length
    )

    const frameSrc = computed<string | null>(() => {
      if (!isVisible.value) {
        return null
      }
      return activeTab.value === 'clients'
        ? clientsFrameSrc.value
        : activeCabinetUrl.value
    })
    useBlitzPostMessage(frameSrc)

    // закрытие через RgsModalAside, чтобы отработала анимация ухода
    const onClose = () => {
      modalRef.value?.onClose()
    }
    const onKeydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }
    const addEscapeListener = () => {
      window.removeEventListener('keydown', onKeydown)
      window.addEventListener('keydown', onKeydown)
    }
    const removeEscapeListener = () => {
      window.removeEventListener('keydown', onKeydown)
    }
    onUnmounted(removeEscapeListener)

    watch(isVisible, async (value) => {
      if (!value) {
        removeEscapeListener()
        activeCabinetUrl.value = null
        return
      }
      addEscapeListener()
      isMobile.value = window.matchMedia(MOBILE_QUERY).matches
      activeTab.value = clientsFrameSrc.value ? 'clients' : 'business'
      activeCabinetUrl.value = null
      requested.value = true
      await store.dispatch('cardsLk/fetch', ctx)
    })

    const onSelect = (item: CardsLkItem) => {
      if (!item.url || !isCabinetClickable(item)) {
        return
      }
      if (item.ymTarget) {
        yaReach(item.ymTarget)
      }
      if (item.action === 'openBlitz') {
        activeCabinetUrl.value = item.url
      } else if (item.action === 'navigate') {
        window.location.assign(item.url)
      }
    }
    const onBack = () => {
      activeCabinetUrl.value = null
    }
    return {
      isVisible,
      isMobile,
      isEmpty,
      fetched,
      activeTab,
      activeCabinetUrl,
      isCabinetFrameOpen,
      clientsFrameSrc,
      authTitle,
      businessItems,
      modalRef,
      onSelect,
      onBack,
      onClose,
    }
  },
})
